import { gql } from '@apollo/client';

export const CERTS_QUERY = gql`
query certificateTemplates {
    certificateTemplates {
      edges {
        node {
          id
          brand {
            id
            name
          }
          createdAt
          description
          name
          templateKey
          certificateTemplateUrl
          certificateProfile {
              id
              name
              description
          }
        }
      }
    }
  }
`;
